import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Printer, PrinterCheck } from "lucide-react";
import { detectQz, onQzStatus } from "../lib/qz";

// Detección automática de QZ Tray al cargar la página; muestra el estado en el encabezado.
export default function QzBadge() {
  const [st, setSt] = useState({ active: false, checked: false, printers: [] });
  const navigate = useNavigate();
  useEffect(() => { const off = onQzStatus(setSt); detectQz(); return off; }, []);
  if (!st.checked) return null;
  const title = st.active ? `QZ Tray conectado · ${st.printers.length} impresora(s)` : "QZ Tray no detectado en este equipo. Ábrelo o instálalo desde qz.io";
  return (
    <button onClick={() => navigate("/settings")} title={title} data-testid="qz-badge"
      className={`hidden md:flex items-center gap-1.5 text-[11px] font-semibold px-3 py-1 rounded-full border transition-colors ${st.active ? "bg-emerald-500/10 border-emerald-500/30 text-emerald-700" : "bg-amber-500/10 border-amber-500/40 text-amber-700"}`}>
      {st.active ? <PrinterCheck size={13} /> : <Printer size={13} />}
      {st.active ? "QZ Tray" : "Sin QZ Tray"}
    </button>
  );
}
